'use client';

import Link from "next/link";
import classes from "./public_header_item.module.css";
import { usePathname } from "next/navigation";

export default function PublicHeaderItem({children, href, onClick, icon, is_mobile}) {
    const path = usePathname();

    return <>
        <Link href={href} title={children} className={`${classes.link} align-items-center w-100 padding-2 gap-3 color-gray-800 ${is_mobile ? "d-flex flex-row " : "show-on-mobile-480"}`} onClick={onClick}>
            {icon}
            {children}
        </Link> 
        <Link href={href} title={children} className={`${is_mobile ? "d-none" : "show-on-pc-480"} ${classes.link} ${(path.startsWith(href) && href !== "") ? classes.active : ''}`} onClick={onClick}>
            {children}
        </Link> 
    </>
}